import { render } from "./NewOrderPage.vue?vue&type=template&id=ab5a8150&ts=true"
import script from "./NewOrderPage.ts?vue&type=script&lang=ts"
export * from "./NewOrderPage.ts?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__